import { RaffleImages } from "../raffle/images";
import { Button, Fade, Grid, Typography } from "@mui/material";
import RaffleTickets from "../raffle/tickets";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { useIsMobileView } from "../../utils/responsive";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { getThemeByAccountId } from "../../utils/styleConstants";
import { useEffect, useState } from "react";
import CountdownTimer from "../common/Countdown";
import { AwardInformation } from "../raffle/awardInformation";
import { PreviewRaffleImages } from "../raffle/preview-images";
import { PAYMENT_METHODS_ICONS } from "../../constants/icons";

interface PreviewRaffle2Props {
  activeRaffle: IRaffle;
}

export const PreviewRaffle2 = ({ activeRaffle }: PreviewRaffle2Props) => {

  const isMobile = useIsMobileView();
  const accountInformation = useAppSelector(({ account }: RootState) => account);
  const [scrolled, setScrolled] = useState(false);



  const handleScroll = () => {
    if (window.scrollY > 500) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Grid container sx={{ background: getThemeByAccountId(accountInformation.id) === 'dark' ? '#000 !important' : '#FFF !important', padding: 0 }}>
      <Grid item xs={12} xl={12} lg={12} md={12} sm={12} padding={0}>
        {
          activeRaffle.launchDate && <Grid p={4}> <CountdownTimer targetEpoch={activeRaffle.launchDate}></CountdownTimer> </Grid>
        }
          <Fade in={scrolled}>
            <Grid
            container
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: getThemeByAccountId(accountInformation.id) === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
              
              color: '#fff',
              padding: '10px',
              zIndex: 10,
              textAlign: 'center',
            }}
          >
            <Grid xs={2} xl={2} lg={2} md={2} sm={2}>
              <img
                src={accountInformation.logo}
                width={60}
                height={60}
                style={{ borderRadius: 20 }}
                alt="Logo"
              />
            </Grid>
            <Grid xs={8} xl={8} lg={8} md={8} sm={8}>
              <Typography paddingLeft={2} variant="h6" fontWeight="bold" fontFamily={"Phrastic"} 
              textTransform={"uppercase"} >
                {accountInformation.name}
              </Typography>
              <Typography paddingLeft={2} variant="body1" fontFamily={"Phrastic"}>
                {activeRaffle.name}
              </Typography>
            </Grid>
          </Grid>
          </Fade>
        
        <Grid pb={2}>
          <RaffleImages images={activeRaffle.awards.flatMap(element => element.images)}></RaffleImages>
        </Grid>

        <Grid container  xs={12} xl={12} lg={12} md={12} sm={12} padding={isMobile ? 0 : 1}>
            {getThemeByAccountId(accountInformation.id) === 'dark' ? <Grid 
            item 
            xl={12} lg={12} md={12} xs={12} sm={12} 
            display={"flex"} 
            justifyContent={"center"}
            sx={{
              position: "relative",
            }}
            paddingBottom={4}
          >
            <Typography 
              variant="h3" 
              textAlign={"center"} 
              fontFamily={"Phrastic"} 
              fontWeight={"bold"} 
              textTransform={"uppercase"} 
              sx={{
                position: "absolute", 
                top: "-60px",
                zIndex: 2,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {activeRaffle.name}
            </Typography>
          </Grid> :  
          <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
            <Typography variant="h3" textAlign={"center"} fontFamily={"Phrastic"} fontWeight={"bold"} textTransform={"uppercase"}>
              {activeRaffle.name}
            </Typography>
          </Grid> }

          {activeRaffle.paymentProd && <Grid mt={5}>
          {activeRaffle.awards.map((award, i) => (
            i < 2 &&
              <Grid item key={`award-${award.name}`} xs={12} xl={12} lg={12} md={12} sm={12}>
              <AwardInformation award={award} />
              </Grid>
            ))}
          </Grid>}
          </Grid>
        <Grid>
      </Grid>


        {activeRaffle.type !== 'lottery' && <Grid sx={{ p: 4, pt: 0 }} pt={4}>
          <Typography variant="h6" fontWeight={"bold"}>Comprar tickets</Typography>
        </Grid>}
        <Grid item  xs={12} xl={12} lg={12} sm={12}>
            <RaffleTickets accountId={accountInformation.id} raffleId={activeRaffle.id} limit={activeRaffle.limit} ticketPriceUSD={activeRaffle.ticketPriceUSD} ticketPrice={activeRaffle.ticketPrice} availablePaymentMethods={activeRaffle.availablePaymentMethods} raffleType={activeRaffle.type} /> 
        </Grid>
      </Grid>
    </Grid>
  );
};
